import makeMutation from "@saleor/hooks/makeMutation";
import gql from "graphql-tag";

import {
  SetMallAutoBookingConfig,
  SetMallAutoBookingConfigVariables
} from "./types/SetMallAutoBookingConfig";
import {
  ToggleAutobooking,
  ToggleAutobookingVariables
} from "./types/ToggleAutobooking";
import {
  ToggleAutobookingPerMall,
  ToggleAutobookingPerMallVariables
} from "./types/ToggleAutobookingPerMall";

export const toggleAutobooking = gql`
  mutation ToggleAutobooking(
    $input: AutoBookingSetIsEnabledInput!
    $mallIds: [ID]
  ) {
    autoBookingSetIsEnabled(mallIds: $mallIds, input: $input) {
      malls {
        id
        name
        hasEnabledAutoBooking
      }
      autoBookingError {
        field
        message
        code
      }
    }
  }
`;
export const useToggleAutobooking = makeMutation<
  ToggleAutobooking,
  ToggleAutobookingVariables
>(toggleAutobooking);

export const toggleAutobookingPerMall = gql`
  mutation ToggleAutobookingPerMall(
    $input: AutoBookingSetIsEnabledInput!
    $mallId: ID
  ) {
    autoBookingSetIsEnabled(mallIds: [$mallId], input: $input) {
      malls {
        id
        name
        hasEnabledAutoBooking
      }
      autoBookingError {
        field
        message
        code
      }
    }
  }
`;

export const useToggleAutobookingPerMall = makeMutation<
  ToggleAutobookingPerMall,
  ToggleAutobookingPerMallVariables
>(toggleAutobookingPerMall);

const setMallAutoBookingConfig = gql`
  mutation SetMallAutoBookingConfig(
    $input: AutobookingConfigUpdateInput!
    $mallId: ID!
  ) {
    setMallAutoBookingConfig(input: $input, mallId: $mallId) {
      mall {
        id
        name
      }
      autoBookingConfig {
        readyStatusMinutes
        collectedStatusMinutes
        anyStatusMinutes
        isEnabled
        updatedAt
        createdAt
        id
        storeType
        courier
      }
      autoBookingError {
        field
        message
        code
      }
    }
  }
`;

export const useSetMallAutoBookingConfig = makeMutation<
  SetMallAutoBookingConfig,
  SetMallAutoBookingConfigVariables
>(setMallAutoBookingConfig);
